import { useEffect } from 'react'
import { setAwsRumInOfficeContextDefault } from '../utils/aws-rum'

const useAwsRum = () => {
  useEffect(() => {
    setAwsRumInOfficeContextDefault().mapErr((err) => {
      console.error('Failed to set RUM user attributes', err)
    })
  }, [])
}

export default useAwsRum
